<template>
    <v-dialog
            v-model="durationConfirmationModal"
            max-width="680"
            persistent
            @keydown.enter="onConfirm"
            @keydown.esc="onCancel"
    >
        <v-card>
            <v-card-title class="mb-4"><h3>{{ "Attention" | t }} </h3></v-card-title>
            <v-card-text class="message-text">
                {{ durationConfirmationMessage }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click.stop="onCancel">{{ 'Cancel' | t }}</v-btn>
                <v-btn color="success" text @click.stop="onConfirm">{{ 'Confirm' | t }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { workOrderMixin } from "@/mixins/work-order-mixin";

export default {
    name: "work-order-list-settings-modal",
    mixins: [workOrderMixin],
    data() {
        return {};
    },
    computed: {
        ...mapState("WorkOrderStore", [
            "durationConfirmationModal", "durationConfirmationMessage"
        ])
    },
    mounted() {
        this.handleKeydown = (event) => {
            if (!this.durationConfirmationModal) return;
            if (event.key === 'Enter') {
                this.onConfirm();
            } else if (event.key === 'Escape') {
                this.onCancel();
            }
        };
        window.addEventListener('keydown', this.handleKeydown);
    },
    destroyed() {
        window.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
        onConfirm() {
            this.$emit('confirm-duration', true);
        },
        onCancel() {
            this.$emit('reject-duration', false);
        }
    }
};
</script>

<style scoped>
.message-text {
    font-size: 15px;
    font-weight: 450;
}
</style>
